import { DataItem } from 'scrivito'

import { DataClassName } from '@/Data/const'
import { DocumentProjectRelation } from '@/Data/DocumentProjectRelation/DocumentProjectRelationDataClass'
import { Quote } from '@/Data/Quote/QuoteDataClass'
import { DataScopeOrder } from '@/Data/types'
import { useDataClassIndex } from '@/hooks/useDataClassIndex'
import { getDataItem } from '@/utils/getDataItem'
import { isString } from '@/utils/isString'

interface Args {
  subjectId: string
  search: string
  order: DataScopeOrder
  listSize: number
  subjectRelation?: 'company' | 'document'
}

interface QuoteRow {
  id: string
  quote: DataItem
  relation?: DataItem
}

export const useQuoteTabData = ({
  subjectId,
  search,
  order,
  listSize,
  subjectRelation = 'company',
}: Args) => {
  const isDocument = subjectRelation === 'document'
  const dataClass = isDocument ? DocumentProjectRelation : Quote
  const filters = isDocument
    ? {
        document: subjectId,
        projectEntity: DataClassName.QUOTE,
        project_search: search,
      }
    : { customer: subjectId }

  const { dataItems, hasMore, loadMore, count } = useDataClassIndex(
    dataClass,
    {
      filters,
      order: [order],
      ...(!isDocument ? { search: search || undefined } : {}),
    },
    listSize,
  )

  const items: QuoteRow[] = dataItems.flatMap((item) => {
    if (!isDocument) {
      return [{ id: item.id(), quote: item }]
    }

    const projectId = item.get('project') as string
    if (!isString(projectId)) return []
    const { dataItem: quote } = getDataItem(Quote, projectId)
    if (!quote) return []

    return [{ id: quote.id(), quote, relation: item }]
  })

  return { items, hasMore, loadMore, count }
}
